'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PageLink = require('containers/PageLink');

var _PageLink2 = _interopRequireDefault(_PageLink);

var _workitem = require('./workitem.css');

var _workitem2 = _interopRequireDefault(_workitem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WorkItem = function WorkItem(_ref) {
  var url = _ref.url,
      title = _ref.title,
      subtitle = _ref.subtitle,
      bg = _ref.bg,
      isInFilter = _ref.isInFilter;

  var itemClass = isInFilter ? _workitem2.default.item : _workitem2.default.itemHidden;

  return _react2.default.createElement(
    _PageLink2.default,
    { to: 'work/' + url, className: itemClass, style: { backgroundImage: 'url(' + bg + ')' } },
    _react2.default.createElement(
      'div',
      { className: _workitem2.default.inner },
      _react2.default.createElement('div', { className: _workitem2.default.overlay }),
      _react2.default.createElement(
        'div',
        { className: _workitem2.default.details },
        _react2.default.createElement('h3', { className: _workitem2.default.title, dangerouslySetInnerHTML: { __html: title } }),
        _react2.default.createElement('h4', { className: _workitem2.default.subtitle, dangerouslySetInnerHTML: { __html: subtitle } })
      )
    )
  );
};

WorkItem.propTypes = {
  url: _react.PropTypes.string,
  title: _react.PropTypes.string,
  subtitle: _react.PropTypes.string,
  bg: _react.PropTypes.string,
  isInFIlter: _react.PropTypes.bool
};

exports.default = WorkItem;


//////////////////
// WEBPACK FOOTER
// ./src/components/WorkItem/WorkItem.js
// module id = 342
// module chunks = 1